import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import LogHistoryName from "../../components/logHistory/LogHistoryDetail/LogHistoryName.tsx";
import {useLocationFormState} from "../../components/logHistory/LogHistoryForm/LogHistoryUpdateForm";
import LogHistoryUpdateFormProvider from "../../components/logHistory/LogHistoryForm/LogHistoryUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const LogHistoryUpdateEditPage = () => {
    
    useTitle(t`Update Log History`);

    const { logHistoryId: id } = useParams();
    
    return (
        <Box data-testid="LogHistory-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="LogHistory-update-title"
                    >
                        <Trans>Edit Log History</Trans>:  <LogHistoryName id={id}/>
                    </Typography>
                    <LogHistoryUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default LogHistoryUpdateEditPage;
